"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserCardUnassigned = exports.UserCard = void 0;
var image_button_1 = require("../../components/button/image.button");
var icons_1 = require("../../components/icon/icons");
var theme_1 = require("../../components/theme");
var theme_2 = require("../../components/theme");
var user_icon_1 = require("../../components/user/user.icon");
var i18n_1 = require("../../i18n");
var render_service_1 = require("../../services/render.service");
var userDisplayName_1 = require("../../util/userDisplayName");
var CSS = {
    container: 'c-UserCard',
    chip: 'c-UserCard--Chip',
    readonly: 'c-UserCard--ReadOnly',
    content: 'c-UserCard__Content',
    icon: 'c-UserCard__Icon',
    name: 'c-UserCard__Name',
    username: 'c-UserCard__Username'
};
var Style = (_a = {},
    _a[CSS.container] = {
        display: 'flex',
        'align-items': 'center',
        cursor: 'pointer',
        'text-align': 'left',
        'line-height': theme_2.DefaultTheme.space(4)
    },
    _a[CSS.chip] = {
        'background-color': theme_2.DefaultTheme.background.lightGrey,
        'border-radius': theme_2.DefaultTheme.space(6)
    },
    _a[CSS.readonly] = {
        cursor: 'default'
    },
    _a[CSS.icon] = {
        'margin-right': theme_2.DefaultTheme.space(1)
    },
    _a[CSS.name] = {
        'margin-right': theme_2.DefaultTheme.space(3)
    },
    _a[CSS.username] = {
        color: theme_2.DefaultTheme.font.color.supporting
    },
    _a);
(0, theme_1.addStyles)(Style);
exports.UserCard = {
    view: function (user, content, ctx) {
        if (ctx === void 0) { ctx = {}; }
        var displayName = (0, userDisplayName_1.userDisplayName)(user);
        return (0, render_service_1.m)('div', { className: "".concat(CSS.container, " ").concat(ctx.readonly ? CSS.readonly : ''), onclick: ctx.action }, [
            (0, render_service_1.m)('div', { className: CSS.icon }, user_icon_1.UserIcon.view(user)),
            (0, render_service_1.m)('div', { className: CSS.content }, [
                (0, render_service_1.m)('div', { className: CSS.name }, [
                    (0, render_service_1.m)('span', content != null ? content : displayName),
                    ctx.me ? (0, render_service_1.m)('span', " (".concat((0, i18n_1.Translate)(i18n_1.T.ME), ")")) : null
                ]),
                displayName !== user.username ? (0, render_service_1.m)('div', { className: CSS.username }, user.username) : null
            ])
        ]);
    },
    viewChip: function (user, ctx) {
        if (ctx === void 0) { ctx = {}; }
        return (0, render_service_1.m)('div', { className: "".concat(CSS.container, " ").concat(CSS.chip, " ").concat(ctx.readonly ? CSS.readonly : ''), onclick: ctx.action }, [
            (0, render_service_1.m)('div', { className: CSS.icon }, user_icon_1.UserIcon.view(user)),
            (0, render_service_1.m)('div', { className: CSS.name }, (0, userDisplayName_1.userDisplayName)(user)),
            ctx.readonly ? null : image_button_1.ImageButton.view(icons_1.MaterialIcon.CLOSE, { onclick: ctx.cancel })
        ]);
    }
};
exports.UserCardUnassigned = {
    view: function (content, ctx) {
        if (ctx === void 0) { ctx = {}; }
        return (0, render_service_1.m)('div', { className: "".concat(CSS.container, " ").concat(ctx.readonly ? CSS.readonly : ''), onclick: ctx.action }, [
            (0, render_service_1.m)('div', { className: CSS.icon }, user_icon_1.UserIcon.view(null)),
            (0, render_service_1.m)('div', { className: CSS.content }, [
                (0, render_service_1.m)('div', { className: CSS.name }, content)
            ])
        ]);
    },
    viewChip: function (ctx) {
        if (ctx === void 0) { ctx = {}; }
        return (0, render_service_1.m)('div', { className: "".concat(CSS.container, " ").concat(CSS.chip, " ").concat(ctx.readonly ? CSS.readonly : ''), onclick: ctx.action }, [
            (0, render_service_1.m)('div', { className: CSS.icon }, user_icon_1.UserIcon.view(null)),
            (0, render_service_1.m)('div', { className: CSS.name }, (0, i18n_1.Translate)(i18n_1.T.COLLECTION_UNASSIGNED)),
            ctx.readonly ? null : image_button_1.ImageButton.view(icons_1.MaterialIcon.CLOSE, { onclick: ctx.cancel })
        ]);
    }
};
//# sourceMappingURL=user.card.js.map